import { RootState } from '@reducers';

export const selectDocumentNew = (state: RootState) => state.userDashboardRouteReducer.documentNew;
